// import { binaryStringToBlob, getMimeTypeFromFileName } from "../util";

export const openInBrowserTypes = [
    // Images
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/svg+xml",
    "image/webp",
    // PDF
    "application/pdf",
    // Text
    "text/plain",
    "text/html",
    "text/css",
    "application/javascript",
    // XML
    "application/xml",
    "text/xml",
    // Video
    "video/mp4",
    "video/webm",
    "video/ogg",
    // Audio
    "audio/mpeg",
    "audio/ogg",
    "audio/wav",
];

export const openInBrowserExtensions = [
    // Images
    "jpg",
    "jpeg",
    "png",
    "gif",
    "svg",
    "webp",
    // PDF
    "pdf",
    // Text
    "txt",
    "html",
    "htm",
    "css",
    "js",
    // XML
    "xml",
    // Video
    "mp4",
    "webm",
    "ogg",
    // Audio
    "mp3",
    "ogg",
    "wav",
];

export function getCurrentDateTextIST(): string {
    // Constants
    const IST_OFFSET_HOURS = 5.5;
    const IST_OFFSET_MILLISECONDS = IST_OFFSET_HOURS * 60 * 60 * 1000;
    const CUTOFF_HOUR = 18; // 6 PM

    // Current date and time
    const now = new Date();

    // Convert current time to IST
    const ISTTime = new Date(now.getTime() + IST_OFFSET_MILLISECONDS);

    // Get the hours in IST
    const hoursIST = ISTTime.getUTCHours();

    // If it's beyond 6 PM IST, increment the day
    if (hoursIST >= CUTOFF_HOUR) {
        ISTTime.setUTCDate(ISTTime.getUTCDate() + 1);
    }

    // Get day, month, and year
    const day = ISTTime.getUTCDate();
    const month = ISTTime.getUTCMonth(); // Months are 0-based
    const year = ISTTime.getUTCFullYear();

    // Month names array
    const monthNames: string[] = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    // Function to get the appropriate suffix for the day
    const getDaySuffix = (day: number): string => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };

    const daySuffix = getDaySuffix(day);

    // Format the date as "7th April, 2024"
    return `${day}${daySuffix} ${monthNames[month]}, ${year}`;
}

export async function uploadFileInChunks(file: File, idType: string) {
    const chunkSize = 2 * 1024 * 1024; // 2 MB chunks
    const totalChunks = Math.ceil(file.size / chunkSize);

    for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const start = chunkIndex * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append("attachmentChunk", chunk);
        // formData.append("chunkIndex", chunkIndex.toString());
        // formData.append("totalChunks", totalChunks.toString());
        // formData.append("fileName", file.name);
        // formData.append("idType", idType);

        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}file/chunk`, {
            method: "POST",
            body: formData,
        });
        const responseData = await response.json();
        console.log(responseData);
    }
    return 0;
};

// export const labelToKey = (label, fieldsData) => {
//     const field = fieldsData.find((field) => field.label === label);
//     return field ? field.key : null;
// };
// export const convertToIndianNumber = (num) => {
//     // Arrays for Indian numbering system
//     const ones = [
//         "",
//         "One",
//         "Two",
//         "Three",
//         "Four",
//         "Five",
//         "Six",
//         "Seven",
//         "Eight",
//         "Nine",
//         "Ten",
//         "Eleven",
//         "Twelve",
//         "Thirteen",
//         "Fourteen",
//         "Fifteen",
//         "Sixteen",
//         "Seventeen",
//         "Eighteen",
//         "Nineteen",
//     ];
//     const tens = [
//         "",
//         "",
//         "Twenty",
//         "Thirty",
//         "Forty",
//         "Fifty",
//         "Sixty",
//         "Seventy",
//         "Eighty",
//         "Ninety",
//     ];

//     // Function to convert a number less than 100 to words
//     function convertLessThanHundred(number) {
//         if (number < 20) {
//             return ones[number];
//         } else {
//             const ten = Math.floor(number / 10);
//             const one = number % 10;
//             return tens[ten] + " " + ones[one];
//         }
//     }

//     // Function to convert a number to words
//     function convertToWords(number) {
//         if (number === 0) return "zero";

//         const crore = Math.floor(number / 10000000);
//         const lakh = Math.floor((number % 10000000) / 100000);
//         const thousand = Math.floor((number % 100000) / 1000);
//         const hundred = Math.floor((number % 1000) / 100);
//         const remaining = number % 100;

//         let result = "";

//         if (crore > 0) {
//             result += convertLessThanHundred(crore) + " Crore ";
//         }

//         if (lakh > 0) {
//             result += convertLessThanHundred(lakh) + " Lakh ";
//         }

//         if (thousand > 0) {
//             result += convertLessThanHundred(thousand) + " Thousand ";
//         }

//         if (hundred > 0) {
//             result += convertLessThanHundred(hundred) + " Hundred ";
//         }

//         if (remaining > 0) {
//             result += convertLessThanHundred(remaining);
//         }

//         return result.trim();
//     }

//     // Split the number into its integer and decimal parts
//     const integerPart = Math.floor(num);
//     const decimalPart = Math.round((num - integerPart) * 100);

//     // Convert the integer part to words
//     let integerWords = convertToWords(integerPart);

//     // Convert the decimal part to words
//     let decimalWords = "";
//     if (decimalPart > 0) {
//         decimalWords = "and " + convertLessThanHundred(decimalPart) + " Paise";
//     }

//     // Combine integer and decimal parts
//     let result = integerWords + " Rupees ";
//     if (decimalWords !== "") {
//         result += decimalWords;
//     }

//     return result;
// };

// export const formatNumberIndianSystem = (num) => {
//     return new Intl.NumberFormat("en-IN", {
//         maximumFractionDigits: 2,
//         minimumFractionDigits: 2,
//         style: "decimal",
//     }).format(num);
// };

// export const isDecimal = (num) => {
//     return !!(num % 1);
// };

// export const getFile = async (idType, id) => {
//     try {
//         const fileDetailsUrl = `${process.env.REACT_APP_SERVER_URL}file/${idType}/${id}`;
//         const fileResponse = await fetch(fileDetailsUrl);
//         const fileJson = await fileResponse.json();
//         const file = await fileJson?.data?.file;
//         if (file)
//             return new File(
//                 [
//                     binaryStringToBlob(
//                         file.fileContent,
//                         getMimeTypeFromFileName(file.fileName)
//                     ),
//                 ],
//                 file.fileName,
//                 { type: getMimeTypeFromFileName(file.fileName) }
//             );
//         return file;
//     } catch {
//         return null;
//     }
// };